import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import debounce from 'lodash.debounce';
import { useState, useEffect, useCallback, useMemo } from 'react';
/**
 * Hook that returns the current window size.
 * Allows on-demand syncing of values via the `sync` function.
 */
export var useWindowSize = function useWindowSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 250 : _ref$delay;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var sync = useCallback(function () {
    var _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;
    setWidth(innerWidth);
    setHeight(innerHeight);
  }, []);
  useEffect(function () {
    var debouncedSync = debounce(sync, delay);
    window.addEventListener('resize', debouncedSync);
    sync();
    return function () {
      return window.removeEventListener('resize', debouncedSync);
    };
  }, [delay, sync]);
  return useMemo(function () {
    return {
      height: height,
      sync: sync,
      width: width
    };
  }, [height, sync, width]);
};
//# sourceMappingURL=useWindowSize.js.map